// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_b02736e","eachWayWrapper":"_a5a2185","rowOne":"_6a1dd1f","rightColumn":"_1331195","heading":"_37e96f7"};